import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { Link, useLocation } from 'react-router-dom';
import RoundButton from 'shared/buttons/RoundButton';
import Spacer from 'shared/layout/Spacer';
import { useStore } from 'models/stores';

export default observer(({ closeModal }) => {
  const {
    uiStore: { t, language },
    companyStore: {
      current: { name },
    },
  } = useStore();
  const { search } = useLocation();

  const dashLink = `/${name}/${language}${search}`;

  return (
    <SuccessModalWrapper>
      <h2>{t('apply_successModal_title')}</h2>
      <div>{t('apply_successModal_text')}</div>
      <Spacer top={40} bottom={20}>
        <Link to={dashLink} onClick={closeModal}>
          <RoundButton>{t('apply_successModal_backToJobs')}</RoundButton>
        </Link>
      </Spacer>
    </SuccessModalWrapper>
  );
});

const SuccessModalWrapper = styled.div`
  text-align: center;
  color: ${(p) => p.theme.textColor};
  font-size: 15px;
  font-family: ${(p) => p.theme.fontFamily};

  > h2 {
    font-family: ${(p) => p.theme.secondFont};
    font-size: 29px;
    color: ${(p) => p.theme.secondaryColor};
    font-weight: bold;
    margin-bottom: 20px;
  }
`;
